<template>
  <MenuItems :items="items" :depth="0" />
</template>

<script>
import MenuItems from "./MenuItems.vue";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
    items: Array
  },
  components: {
    MenuItems
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  display: flex;
  flex-direction: column;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
